import React from "react";
import InfoTooltip from "../InfoTooltip";
import { Target } from "lucide-react";

interface CardProps {
  label: string;
  info?: React.ReactNode;
  content: React.ReactNode;
  progress?: number;
}

const Card = ({ label, info, content, progress }: CardProps) => {
  return (
    <div className="et-analytics-metric" data-metric={label}>
      <div className="et-analytics-metric-label">
        {label === "Completion Rate" && <Target size={18} aria-hidden="true" />}
        <div className="font-mulish text-[#25252599] font-semibold text-sm">
          {(
            {
              "Total Students": "Total students",
              "Average Time Spent": "Average time spent",
              "Lessons Completed": "Lessons completed",
              "Completion Rate": "Completion rate",
              "Not Mastered": "Not mastered",
            } as Record<string, string>
          )[label] ?? label}
        </div>
        {info && (
          <div className="group relative">
            <InfoTooltip info={info} label={`About ${label}`} />
          </div>
        )}
      </div>
      <div className="et-analytics-metric-value">{content}</div>
      {progress !== undefined && (
        <div className="et-completion-track" aria-hidden="true">
          <span
            style={{ width: `${Math.max(0, Math.min(100, progress * 100))}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default Card;
